export enum ECardCloseResponse {
  success = 'success',
  danger = 'danger',
  cancel = 'cancel',
}
